import merge from "lodash/merge";
const mergeReducer = (state, action) => {
    const result = (Array.isArray(state) ? [] : {});
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    merge(result, state, action.value);
    return result;
};
export default mergeReducer;
